// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popper[data-v-655586c2] {\n  margin-top: 3px;\n}\n.el-dropdown-link[data-v-655586c2] {\n  cursor: pointer;\n  font-size: 16px;\n  color: #666;\n}\n.el-dropdown-link.bold[data-v-655586c2] {\n  font-weight: 600;\n}\n.mgr5[data-v-655586c2] {\n  margin-right: 3px;\n}\n.lang-dropdown[data-v-655586c2] {\n  padding: 1px;\n}\n.pp-icon[data-v-655586c2] {\n  -webkit-text-stroke-width: 0.2px;\n  vertical-align: -2px;\n}", ""]);
// Exports
module.exports = exports;
